import { Project } from 'common/types';

export const initialProject: Project = {
    id: 0,
    name: '',
    propertyId: 0,
    ownerId: 0,
    clientId: 0,
    statusId: undefined,
    typeId: '',
    createdById: 0,
};
